import React from 'react';
import { Reveal } from './Reveal';
import { relatedGuides } from '../data/guide';
export function RelatedGuides() {
  return <section aria-labelledby="segui-aprendiendo" className="border-t border-beige/70 bg-warmwhite px-6 py-24 sm:px-10 sm:py-36" data-id="element-130" data-mp="109x6iaaslguj">
      <div className="mx-auto max-w-6xl" data-id="element-131" data-mp="1a6t95ze0f8r6">
        <Reveal data-id="element-132" data-mp="1a5ryvx4tiqai">
          <h2 id="segui-aprendiendo" className="font-serif text-[1.9rem] font-light leading-[1.2] tracking-[-0.01em] text-ink-900 sm:text-[2.6rem]" data-id="element-133" data-mp="1a58febzirtud">
            Seguí aprendiendo
          </h2>
        </Reveal>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-134" data-mp="1xw4b3k73j96w">
          {relatedGuides.map((guide, i) => {
          const isAvailable = guide.status === 'Completado';
          return <Reveal as="li" delay={i * 0.06} key={guide.title} data-id="element-135" data-mp="26wkdsrg0mcap" data-mpi={i}>
                <article className={`group flex h-full flex-col justify-between rounded-[1.5rem] border border-beige/80 p-7 transition-all duration-700 ease-out sm:rounded-[1.75rem] ${isAvailable ? 'bg-cream/70 hover:-translate-y-1 hover:border-sage-200 hover:bg-sage-50' : 'bg-warmwhite'}`} data-id="element-136" data-mp="26uzfqruhsb83">
                  <div data-id="element-137" data-mp="yyi94bl5fo8r">
                    <p className="font-sans text-[0.6rem] font-light uppercase tracking-widest text-ink-400" data-id="element-138" data-mp="yz1jn78gzacr">
                      {guide.index}
                    </p>
                    <h3 className="mt-5 font-serif text-[1.3rem] font-light leading-[1.35] text-ink-900" data-id="element-139" data-mp="13vs4e7v7yu4i">
                      {guide.title}
                    </h3>
                    <p className="mt-4 font-sans text-[0.85rem] font-light leading-[1.8] text-ink-500" data-id="element-140" data-mp="1cqgc04o9onwh">
                      {guide.excerpt}
                    </p>
                  </div>

                  <p className={`mt-10 font-sans text-[0.65rem] font-light uppercase tracking-[0.2em] ${isAvailable ? 'text-sage-600' : 'text-ink-400'}`} data-id="element-141" data-mp="1mpe0j7lp0hfh">
                    {guide.status}
                  </p>
                </article>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}